import { render, staticRenderFns } from "./InvestorHotline.vue?vue&type=template&id=249f6b3c&scoped=true"
import script from "./InvestorHotline.vue?vue&type=script&lang=js"
export * from "./InvestorHotline.vue?vue&type=script&lang=js"
import style0 from "./InvestorHotline.vue?vue&type=style&index=0&id=249f6b3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249f6b3c",
  null
  
)

export default component.exports